// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-45a28257] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.button-vue[data-v-45a28257] {
  position: relative;
  width: fit-content;
  overflow: hidden;
  border: 0;
  padding: 0;
  font-size: var(--default-font-size);
  font-weight: bold;
  min-height: var(--default-clickable-area);
  min-width: var(--default-clickable-area);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: var(--border-radius-element, calc(var(--default-clickable-area) / 2));
  transition-property: color, border-color, background-color;
  transition-duration: 0.1s;
  transition-timing-function: linear;
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue *[data-v-45a28257],
.button-vue span[data-v-45a28257] {
  cursor: pointer;
}
.button-vue[data-v-45a28257]:focus {
  outline: none;
}
.button-vue[data-v-45a28257]:disabled {
  cursor: default;
  opacity: 0.5;
  filter: saturate(0.7);
}
.button-vue:disabled *[data-v-45a28257] {
  cursor: default;
}
.button-vue[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-primary-element-light-hover);
}
.button-vue[data-v-45a28257]:active {
  background-color: var(--color-primary-element-light);
}
.button-vue__wrapper[data-v-45a28257] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.button-vue--end .button-vue__wrapper[data-v-45a28257] {
  justify-content: end;
}
.button-vue--start .button-vue__wrapper[data-v-45a28257] {
  justify-content: start;
}
.button-vue--reverse .button-vue__wrapper[data-v-45a28257] {
  flex-direction: row-reverse;
}
.button-vue--reverse.button-vue--icon-and-text[data-v-45a28257] {
  padding-inline: calc(var(--default-grid-baseline) * 4) var(--default-grid-baseline);
}
.button-vue__icon[data-v-45a28257] {
  height: var(--default-clickable-area);
  width: var(--default-clickable-area);
  min-height: var(--default-clickable-area);
  min-width: var(--default-clickable-area);
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-vue__text[data-v-45a28257] {
  font-weight: bold;
  margin-bottom: 1px;
  padding: 2px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.button-vue--icon-only[data-v-45a28257] {
  line-height: 1;
  width: var(--default-clickable-area) !important;
}
.button-vue--text-only[data-v-45a28257] {
  padding: 0 12px;
}
.button-vue--text-only .button-vue__text[data-v-45a28257] {
  margin-left: 4px;
  margin-right: 4px;
}
.button-vue--icon-and-text[data-v-45a28257] {
  padding-block: 0;
  padding-inline: var(--default-grid-baseline) calc(var(--default-grid-baseline) * 4);
}
.button-vue--wide[data-v-45a28257] {
  width: 100%;
}
.button-vue[data-v-45a28257]:focus-visible {
  outline: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 4px var(--color-main-background) !important;
}
.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-45a28257] {
  outline: 2px solid var(--color-primary-element-text);
  border-radius: var(--border-radius-element, var(--border-radius));
  background-color: transparent;
}
.button-vue--vue-primary[data-v-45a28257] {
  background-color: var(--color-primary-element);
  color: var(--color-primary-element-text);
}
.button-vue--vue-primary[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-primary-element-hover);
}
.button-vue--vue-primary[data-v-45a28257]:active {
  background-color: var(--color-primary-element);
}
.button-vue--vue-secondary[data-v-45a28257] {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue--vue-secondary[data-v-45a28257]:hover:not(:disabled) {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light-hover);
}
.button-vue--vue-tertiary[data-v-45a28257] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-background-hover);
}
.button-vue--vue-tertiary-no-background[data-v-45a28257] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-no-background[data-v-45a28257]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-45a28257] {
  color: var(--color-primary-element-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-45a28257]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-success[data-v-45a28257] {
  background-color: var(--color-success);
  color: white;
}
.button-vue--vue-success[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-success-hover);
}
.button-vue--vue-success[data-v-45a28257]:active {
  background-color: var(--color-success);
}
.button-vue--vue-warning[data-v-45a28257] {
  background-color: var(--color-warning);
  color: white;
}
.button-vue--vue-warning[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-warning-hover);
}
.button-vue--vue-warning[data-v-45a28257]:active {
  background-color: var(--color-warning);
}
.button-vue--vue-error[data-v-45a28257] {
  background-color: var(--color-error);
  color: white;
}
.button-vue--vue-error[data-v-45a28257]:hover:not(:disabled) {
  background-color: var(--color-error-hover);
}
.button-vue--vue-error[data-v-45a28257]:active {
  background-color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcButton-BlkIlpQf.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,yCAAyC;EACzC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oFAAoF;EACpF,0DAA0D;EAC1D,yBAAyB;EACzB,kCAAkC;EAClC,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mFAAmF;AACrF;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mFAAmF;AACrF;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oDAAoD;EACpD,iEAAiE;EACjE,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;EACE,8CAA8C;EAC9C,0DAA0D;AAC5D;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-45a28257] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.button-vue[data-v-45a28257] {\n  position: relative;\n  width: fit-content;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  font-size: var(--default-font-size);\n  font-weight: bold;\n  min-height: var(--default-clickable-area);\n  min-width: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: var(--border-radius-element, calc(var(--default-clickable-area) / 2));\n  transition-property: color, border-color, background-color;\n  transition-duration: 0.1s;\n  transition-timing-function: linear;\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue *[data-v-45a28257],\n.button-vue span[data-v-45a28257] {\n  cursor: pointer;\n}\n.button-vue[data-v-45a28257]:focus {\n  outline: none;\n}\n.button-vue[data-v-45a28257]:disabled {\n  cursor: default;\n  opacity: 0.5;\n  filter: saturate(0.7);\n}\n.button-vue:disabled *[data-v-45a28257] {\n  cursor: default;\n}\n.button-vue[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue[data-v-45a28257]:active {\n  background-color: var(--color-primary-element-light);\n}\n.button-vue__wrapper[data-v-45a28257] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.button-vue--end .button-vue__wrapper[data-v-45a28257] {\n  justify-content: end;\n}\n.button-vue--start .button-vue__wrapper[data-v-45a28257] {\n  justify-content: start;\n}\n.button-vue--reverse .button-vue__wrapper[data-v-45a28257] {\n  flex-direction: row-reverse;\n}\n.button-vue--reverse.button-vue--icon-and-text[data-v-45a28257] {\n  padding-inline: calc(var(--default-grid-baseline) * 4) var(--default-grid-baseline);\n}\n.button-vue__icon[data-v-45a28257] {\n  height: var(--default-clickable-area);\n  width: var(--default-clickable-area);\n  min-height: var(--default-clickable-area);\n  min-width: var(--default-clickable-area);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.button-vue__text[data-v-45a28257] {\n  font-weight: bold;\n  margin-bottom: 1px;\n  padding: 2px 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.button-vue--icon-only[data-v-45a28257] {\n  line-height: 1;\n  width: var(--default-clickable-area) !important;\n}\n.button-vue--text-only[data-v-45a28257] {\n  padding: 0 12px;\n}\n.button-vue--text-only .button-vue__text[data-v-45a28257] {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.button-vue--icon-and-text[data-v-45a28257] {\n  padding-block: 0;\n  padding-inline: var(--default-grid-baseline) calc(var(--default-grid-baseline) * 4);\n}\n.button-vue--wide[data-v-45a28257] {\n  width: 100%;\n}\n.button-vue[data-v-45a28257]:focus-visible {\n  outline: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 4px var(--color-main-background) !important;\n}\n.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-45a28257] {\n  outline: 2px solid var(--color-primary-element-text);\n  border-radius: var(--border-radius-element, var(--border-radius));\n  background-color: transparent;\n}\n.button-vue--vue-primary[data-v-45a28257] {\n  background-color: var(--color-primary-element);\n  color: var(--color-primary-element-text);\n}\n.button-vue--vue-primary[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-hover);\n}\n.button-vue--vue-primary[data-v-45a28257]:active {\n  background-color: var(--color-primary-element);\n}\n.button-vue--vue-secondary[data-v-45a28257] {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue--vue-secondary[data-v-45a28257]:hover:not(:disabled) {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue--vue-tertiary[data-v-45a28257] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-background-hover);\n}\n.button-vue--vue-tertiary-no-background[data-v-45a28257] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-no-background[data-v-45a28257]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-45a28257] {\n  color: var(--color-primary-element-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-45a28257]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-success[data-v-45a28257] {\n  background-color: var(--color-success);\n  color: white;\n}\n.button-vue--vue-success[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-success-hover);\n}\n.button-vue--vue-success[data-v-45a28257]:active {\n  background-color: var(--color-success);\n}\n.button-vue--vue-warning[data-v-45a28257] {\n  background-color: var(--color-warning);\n  color: white;\n}\n.button-vue--vue-warning[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-warning-hover);\n}\n.button-vue--vue-warning[data-v-45a28257]:active {\n  background-color: var(--color-warning);\n}\n.button-vue--vue-error[data-v-45a28257] {\n  background-color: var(--color-error);\n  color: white;\n}\n.button-vue--vue-error[data-v-45a28257]:hover:not(:disabled) {\n  background-color: var(--color-error-hover);\n}\n.button-vue--vue-error[data-v-45a28257]:active {\n  background-color: var(--color-error);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
